import { useCallback, useEffect, useMemo } from 'react';
import { ShopList } from '~/components/ui/ShopList';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, WalletType } from '~/shared';
import { useBuy } from '../../hooks';
import {
	setActiveList,
	setActiveListIndex,
	setActiveStage,
	setMaxListIndex,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { CategoryImages, CategoryNames } from '../CategoryTab';
import { ListTabItem } from '../ListTabItem';

const ListTab: React.FC = () => {
	const dispatch = useLayoutDispatch();
	const activeListIndex = useLayoutSelector(
		(state) => state.vehicleService.activeListIndex,
	);
	const maxListIndex = useLayoutSelector(
		(state) => state.vehicleService.maxListIndex,
	);
	const activeCategory = useLayoutSelector(
		(state) => state.vehicleService.activeCategory,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());

	const consumables = useObservable(
		rage.vehicleServiceStation.getConsumables(),
	);

	const { handleBuy } = useBuy();

	const handleSelectItem = (index: number | null) =>
		dispatch(setActiveListIndex(index));

	const handleBack = useCallback(() => {
		dispatch(setActiveStage('category'));
	}, []);

	useEffect(() => {
		if (activeListIndex || activeListIndex === 0) {
			const activeItem = consumables[activeListIndex];
			const itemDiv = document.getElementById(`service-${activeItem.id}`);
			if (itemDiv !== null) {
				setTimeout(() => {
					itemDiv.scrollIntoView({ block: 'nearest' });
				}, 50);
			}
		}
	}, [activeListIndex]);

	useInputAction(InputAction.CommonMenuAccept, () => {
		if (activeListIndex === null || !!modalState) {
			return;
		}

		handleBuy(WalletType.Cash);
	});

	const visibleConsumables = useMemo(
		() => consumables.filter((e) => e.group === activeCategory),
		[consumables],
	);

	useEffect(() => {
		if (!activeCategory) return;

		dispatch(setMaxListIndex(visibleConsumables.length - 1));
		dispatch(setActiveList(visibleConsumables));
	}, [visibleConsumables]);

	if (!activeCategory || activeCategory === 'engine') {
		return;
	}

	return (
		<ShopList
			icon={CategoryImages[activeCategory]}
			title={CategoryNames[activeCategory]}
			style={{ marginTop: 30 }}
			handleBack={handleBack}
			activeIndex={activeListIndex}
			maxIndex={maxListIndex}
			handleCheckInstall={() => false}
			handleSelect={handleSelectItem}
		>
			{visibleConsumables.map((item, index) => (
				<ListTabItem
					item={item}
					index={index}
					activeCategory={activeCategory}
					activeListIndex={activeListIndex}
					handleSelect={handleSelectItem}
					key={index}
				/>
			))}
		</ShopList>
	);
};

export { ListTab };
